import { decodeSquawk } from "../lib/squawk.js";
import "./SquawkInfo.css";

const ALERT_CODES = new Set(["7500", "7600", "7700"]);

export default function SquawkInfo({ squawk }) {
  const info = decodeSquawk(squawk);
  if (!info) return null;

  const alert = ALERT_CODES.has(info.code);
  const className = [
    "squawk-info",
    info.special ? "special" : "",
    alert ? "alert" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={className} role={alert ? "alert" : undefined}>
      <div className="squawk-info-head">
        <span className="squawk-info-code">{info.code}</span>
        <span className="squawk-info-label">{info.label}</span>
      </div>
      <p className="squawk-info-desc">{info.description}</p>
    </div>
  );
}
